import { useMatch, useRoutes } from "react-router-dom"

import { DetailSegmentSelectListener, SegmentSelectListener } from "@l2r-front/l2r-common"
import { MapAdapterRoad, MapAdapterBoundingBox, MapAdapterFeature } from "@l2r-front/l2r-networks"
import { NavigateWithParams, useUrlParams } from "@l2r-front/l2r-utils"

import { APP_ROAD } from "../../../../common/constants/appRoad"
import { MODULE_ROADWORKS } from "../../../../common/constants/modules"
import { RoadworkSectionSidebar } from "../../containers/RoadworkSectionSidebar"
import { RoadworksRoadSidebar } from "../../containers/RoadworksRoadSidebar"
import { RoadworksSidebar } from "../../containers/RoadworksSidebar"

import { RoadworkValidator } from "../RoadworkValidator/RoadworkValidator"

export const RoadworksMobileRoutes = () => {

    const match = useMatch(`:slugId/${APP_ROAD}/${MODULE_ROADWORKS}/:road/:roadworkUuid`)
    const { getParams } = useUrlParams()
    const searchParams = getParams()

    const roadworksMobileRoutes = useRoutes([
        {
            path: "/",
            element:
                <>
                    <MapAdapterBoundingBox />
                    <SegmentSelectListener />
                    <RoadworksSidebar />
                </>,
        },
        {
            path: "/:road",
            element:
                <>
                    <RoadworksRoadSidebar />
                    <DetailSegmentSelectListener />
                    <MapAdapterRoad />
                </>,
        },
        {
            path: "/:road/:roadworkUuid/*",
            element: <RoadworkValidator>
                <MapAdapterFeature
                    featureId={match?.params?.roadworkUuid}
                />
                <RoadworkSectionSidebar />
            </RoadworkValidator>,
        },
        {
            path: "/:road/*",
            element: <NavigateWithParams replace to={`../:road?${searchParams}`} />,
        },
    ])

    return roadworksMobileRoutes
}